module.exports = __webpack_public_path__ + "img/caixa.54dc8b8d.svg";